import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  toString336ienavfnzn0 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance3ax1g1upf6nuo as CLASS_getInstance,
  OBJECT_getInstance2hwgzvvdc8p80 as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstancen9ln5ytvklfv as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance2bqk1h54tdzgh as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstancehe6v7kxreu2f as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance29en1y99grgx1 as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstancehpp5w6ty1u0b as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.n2s_1.q2q();
  $this.c1s(discriminator);
  $this.n2s_1.t2q(_Char___init__impl__6a9atx(58));
  $this.n2s_1.s2q();
  $this.c1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(composer, json, mode, modeReuseCache) {
        return new.target.e2u(composer, json, mode, modeReuseCache);
      }
      static e2u(composer, json, mode, modeReuseCache) {
        var $this = this.q1r();
        $this.n2s_1 = composer;
        $this.o2s_1 = json;
        $this.p2s_1 = mode;
        $this.q2s_1 = modeReuseCache;
        $this.r2s_1 = $this.o2s_1.m1r();
        $this.s2s_1 = $this.o2s_1.s2l_1;
        $this.t2s_1 = false;
        $this.u2s_1 = null;
        $this.v2s_1 = null;
        var i = $this.p2s_1.w1_1;
        if (!($this.q2s_1 == null)) {
          if (!($this.q2s_1[i] === null) || !($this.q2s_1[i] === $this)) {
            $this.q2s_1[i] = $this;
          }
        }
        return $this;
      }
      x2n() {
        return this.o2s_1;
      }
      static w2s(output, json, mode, modeReuseCache) {
        return this.e2u(Composer(output, json), json, mode, modeReuseCache);
      }
      m1r() {
        return this.r2s_1;
      }
      v1s(descriptor, index) {
        return this.s2s_1.f2n_1;
      }
      q1s(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.x2n().s2l_1.n2n_1) {
            serializer.h1m(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.x2n().s2l_1.v2n_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.x2n().s2l_1.v2n_1.w1_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.g1m().c1p();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.g1m(), this.x2n()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.g1m()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().n2(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.x2n(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.g1m().c1p());
            var serialName = actualSerializer.g1m().j1n();
            this.u2s_1 = baseClassDiscriminator;
            this.v2s_1 = serialName;
          }
          actualSerializer.h1m(this, value);
        }
      }
      x1q(descriptor) {
        var newMode = switchMode(this.o2s_1, descriptor);
        if (!(newMode.x2t_1 === _Char___init__impl__6a9atx(0))) {
          this.n2s_1.t2q(newMode.x2t_1);
          this.n2s_1.o2q();
        }
        var discriminator = this.u2s_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.v2s_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.j1n() : tmp0_elvis_lhs);
          this.u2s_1 = null;
          this.v2s_1 = null;
        }
        if (this.p2s_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.q2s_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().e2u(this.n2s_1, this.o2s_1, newMode, this.q2s_1) : tmp2_elvis_lhs;
      }
      y1q(descriptor) {
        if (!(this.p2s_1.y2t_1 === _Char___init__impl__6a9atx(0))) {
          this.n2s_1.p2q();
          this.n2s_1.r2q();
          this.n2s_1.t2q(this.p2s_1.y2t_1);
        }
      }
      r1r(descriptor, index) {
        switch (this.p2s_1.w1_1) {
          case 1:
            if (!this.n2s_1.n2q_1) {
              this.n2s_1.t2q(_Char___init__impl__6a9atx(44));
            }

            this.n2s_1.q2q();
            break;
          case 2:
            if (!this.n2s_1.n2q_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.n2s_1.t2q(_Char___init__impl__6a9atx(44));
                this.n2s_1.q2q();
                tmp_0 = true;
              } else {
                this.n2s_1.t2q(_Char___init__impl__6a9atx(58));
                this.n2s_1.s2q();
                tmp_0 = false;
              }
              tmp.t2s_1 = tmp_0;
            } else {
              this.t2s_1 = true;
              this.n2s_1.q2q();
            }

            break;
          case 3:
            if (index === 0)
              this.t2s_1 = true;
            if (index === 1) {
              this.n2s_1.t2q(_Char___init__impl__6a9atx(44));
              this.n2s_1.s2q();
              this.t2s_1 = false;
            }

            break;
          default:
            if (!this.n2s_1.n2q_1) {
              this.n2s_1.t2q(_Char___init__impl__6a9atx(44));
            }

            this.n2s_1.q2q();
            this.c1s(getJsonElementName(descriptor, this.o2s_1, index));
            this.n2s_1.t2q(_Char___init__impl__6a9atx(58));
            this.n2s_1.s2q();
            break;
        }
        return true;
      }
      r1s(descriptor, index, serializer, value) {
        if (!(value == null) || this.s2s_1.k2n_1) {
          super.r1s(descriptor, index, serializer, value);
        }
      }
      e1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.n2s_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.n2s_1;
          } else {
            var tmp0 = this.n2s_1.m2q_1;
            var p1 = this.t2s_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().e2u(tmp$ret$0, this.o2s_1, this.p2s_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.n2s_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.n2s_1;
          } else {
            var tmp0_0 = this.n2s_1.m2q_1;
            var p1_0 = this.t2s_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().e2u(tmp$ret$2, this.o2s_1, this.p2s_1, null);
        } else if (!(this.u2s_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.v2s_1 = descriptor.j1n();
          tmp = this;
        } else {
          tmp = super.e1s(descriptor);
        }
        return tmp;
      }
      t1r() {
        this.n2s_1.v2q('null');
      }
      u1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.e2r(value);
        }
      }
      v1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.z2q(value);
        }
      }
      w1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.b2r(value);
        }
      }
      x1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.c2r(value);
        }
      }
      y1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.d2r(value);
        }
      }
      z1r(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.x2q(value);
        }
        if (!this.s2s_1.p2n_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      a1s(value) {
        if (this.t2s_1) {
          this.c1s(value.toString());
        } else {
          this.n2s_1.y2q(value);
        }
        if (!this.s2s_1.p2n_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      b1s(value) {
        this.c1s(toString(value));
      }
      c1s(value) {
        return this.n2s_1.f2r(value);
      }
      d1s(enumDescriptor, index) {
        this.c1s(enumDescriptor.g1p(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.d1p() && get_unsignedNumberDescriptors().t2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.d1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).g1m(), serializer_0(Companion_getInstance_0()).g1m(), serializer_1(Companion_getInstance_1()).g1m(), serializer_2(Companion_getInstance_2()).g1m()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
